import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ProjectController::index
* @see app/Http/Controllers/ProjectController.php:16
* @route '/stavby'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/stavby',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectController::index
* @see app/Http/Controllers/ProjectController.php:16
* @route '/stavby'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectController::index
* @see app/Http/Controllers/ProjectController.php:16
* @route '/stavby'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::index
* @see app/Http/Controllers/ProjectController.php:16
* @route '/stavby'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectController::show
* @see app/Http/Controllers/ProjectController.php:29
* @route '/stavba/{project}'
*/
export const show = (args: { project: string | number | { slug: string | number } } | [project: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/stavba/{project}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectController::show
* @see app/Http/Controllers/ProjectController.php:29
* @route '/stavba/{project}'
*/
show.url = (args: { project: string | number | { slug: string | number } } | [project: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { project: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.slug
        : args.project,
    }

    return show.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectController::show
* @see app/Http/Controllers/ProjectController.php:29
* @route '/stavba/{project}'
*/
show.get = (args: { project: string | number | { slug: string | number } } | [project: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::show
* @see app/Http/Controllers/ProjectController.php:29
* @route '/stavba/{project}'
*/
show.head = (args: { project: string | number | { slug: string | number } } | [project: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectController::randomProjects
* @see app/Http/Controllers/ProjectController.php:36
* @route '/random-projects'
*/
export const randomProjects = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: randomProjects.url(options),
    method: 'get',
})

randomProjects.definition = {
    methods: ["get","head"],
    url: '/random-projects',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectController::randomProjects
* @see app/Http/Controllers/ProjectController.php:36
* @route '/random-projects'
*/
randomProjects.url = (options?: RouteQueryOptions) => {
    return randomProjects.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectController::randomProjects
* @see app/Http/Controllers/ProjectController.php:36
* @route '/random-projects'
*/
randomProjects.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: randomProjects.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::randomProjects
* @see app/Http/Controllers/ProjectController.php:36
* @route '/random-projects'
*/
randomProjects.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: randomProjects.url(options),
    method: 'head',
})

const ProjectController = { index, show, randomProjects }

export default ProjectController